import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Row, Tabs, message, Badge, Checkbox } from 'antd';
import ProForm, { ProFormInstance } from '@ant-design/pro-form';
import { FileUploadUtility, WdiFileList } from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import DynamicInformation from '../../components/DynamicInformation';
import BudgetInformation from '../../components/BudgetInformation';
import { FormPageProps, WdiFormPageTitle } from '@/components/WdiBus/FormPage';
import { initApprovalPageContext, ViewEntityProps } from '../../components/data';
import { ResponseStatus } from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import { DataOptions } from '@/services/basic/metadata';
import { WdiPanel } from '@/components/WdiControls/WdiPanel';
import { WdiCardTitle, wdiCore, WdiInput, WdiStaffCard, WdiTextArea } from '@/components/WdiControls';
import { FormSADetailsForApprovalPanel } from '../../FreeGoodsApply/components/details';
import { EC } from '@/services/mdm/ec';
import { Enum } from '@/enums/system';
import { ProjectToolTipApp } from '../../components/ProjectCmpt';
import { FormSaDetail } from '@/services/sales/sa';
import SalesAndCost from '../../components/SalesAndCost';
import { SAWarningApprovalApp } from '../../components/WarningInformation';
import { FormSa } from '@/services/sales/sa';
import ReleatedActivitiesApp from '../../components/ReleatedActivities';
import { ActivityType } from '@/services/mdm/ActivityType';

const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/activityapi/saButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "CopyButton",
        "InterveneFlowButton",
        "ClosedButton",
        "OpenedButton",
        // "CompleteDeliveryButton"
      ]
    }
  ],
  errorParams: [
    {
      url: "/activityapi/saButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};
const approvalConfig: any = {
  params: {
    url: "/activityapi/saButtons/get",
    keys: [
      "ApprovalButton"
    ]
  }
};

const FGActivityApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [warningCount, setWarningCount] = useState<number>(0);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [releatedActivitiesProps, setReleatedActivitiesProps] = useState<any>();

  const onDetailsChange = (data: any) => {
    setDataSource(DataStore.init(data));
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        if (viewEntity.form) {
          formRef.current?.setFieldsValue({
            isSpecialApprove: viewEntity.form.isSpecialApprove
          })
        }

        if (viewEntity.formSa) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSa?.activityName,
            activityDate: wdiCore.Date.Join(viewEntity.formSa?.activityStartDate, viewEntity.formSa?.activityEndDate),
            fileInfo: FileUploadUtility.parse(viewEntity.formSa?.fileName, viewEntity.formSa?.filePath),
            remark: viewEntity.formSa?.remark,
            project: viewEntity.budgetProject,
          });

          if (viewEntity.formSa.activityTypeId) {
            ActivityType.get(viewEntity.formSa.activityTypeId).then((response) => {
              formRef.current?.setFieldsValue({
                activityTypeName: response.data.activityTypeName
              });
            });
          }

          const formSaId = viewEntity.formSa?.formSaId ?? 0;

          FormSa.Buttons.countOfWarning(formSaId).then(response => {
            setWarningCount(response.data);
          });
          var soldToCodes: any[] = [];
          FormSaDetail.getFgEx(formSaId).then((response) => {
            setDataSource(DataStore.init(response.data));

            if (response && response.data.length > 0) {
              EC.get(Number(response.data[0].ecId)).then((response) => {
                formRef.current?.setFieldsValue({
                  ecName: response.data.ecName
                });
              });
              response.data.map(item => {
                if (soldToCodes.indexOf(item.soldToCode) < 0) {
                  soldToCodes.push(item.soldToCode);
                }
              });
              setReleatedActivitiesProps({
                soldTos: soldToCodes,
                activityStartDate: String(viewEntity.formSa?.activityStartDate),
                activityEndDate: String(viewEntity.formSa?.activityEndDate),
                pageGroupId: viewEntity.formSa?.pageGroupId,
                formNo: viewEntity.form?.formNo,
              });
            }
          });
        }
        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `免费货类活动申请单【${entity.form?.formNo}】`;
      DataOptions.search({ typeGroup: 3, value: entity.form?.statusId }).then(response => {
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (response.data && response.data.length > 0) {
          title += `，${response.data[0].name}`;
          if (props.setPageTitle) props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={entity?.form}
              useCaseId={Enum.UseCase.SA}
              moreConfig={moreConfig}
              approvalConfig={approvalConfig} />
          );
        }
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId} />
      <Tabs defaultActiveKey="1" size="large">
        <TabPane tab={<span>活动信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => { return (<></>) },
            }}
          >
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title='活动基本信息' />} collapsed={true} >
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="activityName" label="活动名称">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="activityTypeName" label="活动类型">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="activityDate" label="活动期间">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="ecName" label="费用项">
                    <WdiInput readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="isSpecialApprove" valuePropName="checked" label="是否需特批">
                    <Checkbox disabled />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="project" label="专项项目">
                    <ProjectToolTipApp />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="方案简述" >
                    <WdiTextArea rows={4} readOnly />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => { return e.fileList || []; }}
                  >
                    <WdiFileList fileList={FileUploadUtility.parse(entity?.formSa?.fileName, entity?.formSa?.filePath)} />
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          <FormSADetailsForApprovalPanel dataSource={dataSource} pid={props.data?.formId} onChange={onDetailsChange} />
        </TabPane>
        <TabPane tab={<span>预算信息</span>} key="2">
          <BudgetInformation formId={entity?.form?.formId} />
        </TabPane>
        <TabPane tab={<span>销量与费用</span>} key="3">
          <SalesAndCost formSaId={entity?.form?.formId} pageTypeId={entity?.form?.pageTypeId} />
        </TabPane>
        <TabPane tab={<span>相关活动</span>} key="4">
          <ReleatedActivitiesApp {...releatedActivitiesProps} />
        </TabPane>
        <TabPane tab={<><span>警示信息</span>
          <Badge count={warningCount}
            style={{ color: "black", boxShadow: "none", background: "none", top: "-20px", right: "-15px", position: 'absolute' }}>
          </Badge></>
        } key="5">
          <SAWarningApprovalApp formId={entity?.form?.formId} />
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="6">
          <DynamicInformation formId={entity?.form?.formId} formTypeId={entity?.form?.formTypeId} pageTypeId={entity?.form?.pageTypeId} useCaseId={Enum.UseCase.SA} />
        </TabPane>
      </Tabs>
    </>
  );
};
export default FGActivityApprovalApp;
